import { render, staticRenderFns } from "./InventorySelector.vue?vue&type=template&id=36ea7376&scoped=true"
import script from "./InventorySelector.vue?vue&type=script&lang=js"
export * from "./InventorySelector.vue?vue&type=script&lang=js"
import "./InventorySelector.vue?vue&type=style&index=0&id=36ea7376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea7376",
  null
  
)

export default component.exports